import { type MCPServerInfo } from '../../types';

const FreshserviceServer: MCPServerInfo = {
  serverId: 'FRESHSERVICE',
  name: 'Freshservice',
  slug: 'freshservice',
  description: 'Freshservice MCP Server',
  source: {
    sourceType: 'REPOSITORY',
    type: 'COMMUNITY',
    repositoryUrl: 'https://github.com/effytech/freshservice_mcp',
    commitSha: '7626a5e',
    packageType: 'npm',
    packageName: ''
  },
  authenticationType: 'STATIC_CREDS',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: ['freshserviceApiKey', 'freshserviceDomain'],
    properties: {
      freshserviceApiKey: {
        type: 'string',
        description: 'Freshservice API key',
        sensitive: true
      },
      freshserviceDomain: {
        type: 'string',
        description: 'Freshservice Domain (e.g., yourcompany.freshservice.com)',
        sensitive: false
      }
    }
  },
  deprecated: true
};

export default FreshserviceServer;
